<template>
  <div class="flex flex-col place-content-center">
    <div class="flex flex-col gap-2">
      <h2 class="text-5xl font-bold leading-[3.5rem] tracking-[-0.04rem] text-neutral-800">
        {{ t('auth.enter_mfa.title') }}
      </h2>
      <p class="text-[1.125rem] font-semibold leading-[1.4375rem] tracking-[-0.02rem] text-neutral-500">
        {{ t(`auth.enter_mfa.${type}.under_title`) }}
      </p>
    </div>

    <form class="mt-12 flex w-[29.625rem] flex-col place-content-center gap-2" @submit.prevent="onSubmit">
      <infuse-field :label="t('auth.enter_mfa.otp')">
        <infuse-input
          v-model="form.otp"
          type="text"
          :placeholder="t('auth.enter_mfa.otp')"
          :tabindex="1"
          required
          autofocus
        />
      </infuse-field>

      <div class="flex items-center justify-end gap-4">
        <infuse-button size="large" :loading="loading" type="submit" :tabindex="3">
          {{ t('auth.enter_mfa.submit') }}
        </infuse-button>
      </div>
    </form>
  </div>
</template>

<script lang="ts" setup>
import { InfuseButton, InfuseField, InfuseInput } from '@infuse/ui/components';
import { reactive } from 'vue';
import { useI18n } from 'vue-i18n';
import { COGNITO_MFA_TYPE } from '@infuse/auth/services';

interface Props {
  loading?: boolean;
  type?: COGNITO_MFA_TYPE;
}

interface Emits {
  (e: 'submit', form: { otp: string }): void;
}

withDefaults(defineProps<Props>(), {
  type: COGNITO_MFA_TYPE.TOTP
})
const emit = defineEmits<Emits>();

const { t } = useI18n();

const form = reactive({
  otp: ''
});

function onSubmit() {
  emit('submit', form);
}
</script>
